import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const StatusDot = ({ active, small }) => (
  <div className={classNames(styles.statusDot, active && styles.active, small && styles.small)}>
    &bull;
  </div>
);
